module.exports = __webpack_public_path__ + "bin/3abd3347ffd51d9ad7bb327de9c78a75.jpg";